<template>
  <AwlModalCard class="px-5 py-4" :border="false">
    <h3 class="text-primary text-center mb-3">{{ cardTitle }}</h3>
    <button class="btn small btn-outline-secondary" @click="goBack">
      <i class="fas fa-angle-left mr-1"></i>
      Indietro
    </button>

    <img :src="cardImageSrc" class="d-block w-50 mx-auto mb-3" />
    <p class="small text-muted">
      {{ cardContent }}
    </p>

    <div class="d-flex justify-content-between align-items-end">
      <div class="start-forecast-date">
        <FormContainer>
          <FormInputWidget :label="labelDateText">
            <template #default="{ inputId }">
              <MonthPicker :id="inputId" v-model="yearMonth" />
            </template>
          </FormInputWidget>
        </FormContainer>
      </div>
      <button class="btn btn-primary" :disabled="!yearMonth" @click="continueConfig">{{ actionButtonText }}</button>
    </div>
  </AwlModalCard>
</template>

<script>

export default {
  components: {
    AwlModalCard: () => import('@/views/components/Layout/Card/AwlModalCard.vue'),
    FormContainer: () => import('@/libs/Form/components/FormContainer.vue'),
    FormInputWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputWidget.vue'),
    MonthPicker: () => import('@/libs/Form/components/Inputs/FormInputMonthPicker.vue'),
  },
  props: {
    hasBalance: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      yearMonth: null,
    };
  },
  computed: {
    cardTitle () {
      return this.hasBalance ? 'A che mese risale il tuo bilancio?' : 'Determina inizio forecasting';
    },
    cardContent () {
      return this.hasBalance ? 'Inserire la data (mese e anno) del bilancio da inserire' : 'Si consiglia di inserire il mese successivo alla data del bilancio inserito o, per le startup il mese dell\'avvio dell\'attività';
    },
    cardImageSrc () {
      return this.hasBalance ? require('@/assets/images/balance-date.png') : require('@/assets/images/balance-question-mark.png');
    },
    labelDateText () {
      return this.hasBalance ? 'Data del bilancio' : 'Data di inizio previsione';
    },
    actionButtonText () {
      return this.hasBalance ? 'Avanti' : 'Inizia ad usare RFF';
    },
    year () {
      if (!this.yearMonth) {
        return null;
      }

      const parts = this.yearMonth.split('-');

      return parseInt(parts[0]) || null;
    },
    month () {
      if (!this.yearMonth) {
        return null;
      }

      const parts = this.yearMonth.split('-');

      return parseInt(parts[1]) || null;
    },
  },
  methods: {
    continueConfig () {
      this.$emit('selectMonth', {
        year: this.year,
        month: this.month,
      });
    },
    goBack () {
      this.$emit('goBack');
    },
  },
};

</script>
